import React, { useContext } from 'react';
import RadioButtonGroup from '../RadioButtonGroup/RadioButtonGroup';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function StaffCheckInSettings({ onChange }) {
  const environmentContext = useContext(EnvironmentContext);
  const { organization } = environmentContext;

  if (logComponent('StaffCheckInSettings')) { console.debug('StaffCheckInSettings rendered'); }

  const handleChange = (arg) => {
    if (logComponent('StaffCheckInSettings')) { console.debug('StaffCheckInSettings handleChange'); }
    if (onChange) onChange(arg);
  }
  return (
    <dl className="Staff-Checkin-Settings">
      <dt>Staff notes requirement</dt>
      <dd>
        <RadioButtonGroup
          name="staffNote"
          options={[
            { text: 'Required' },
            { text: 'Optional' }
          ]}
          initialSelection={{ text: organization.isStaffCheckHistoryStaffNoteRequired ? 'Required' : 'Optional' }}
          onChange={handleChange} />
      </dd>
      <dt>Family notes requirement</dt>
      <dd>
        <RadioButtonGroup
          name="familyNote"
          options={[
            { text: 'Required' },
            { text: 'Optional' }
          ]}
          initialSelection={{ text: organization.isStaffCheckHistoryFamilyNoteRequired ? 'Required' : 'Optional' }}
          onChange={handleChange} />
      </dd>
    </dl>
  );
}

